<ng-container [formGroup]="form">
	<div formArrayName="movers" class='movers' [ngClass]="'view-'+viewMode">
		<ng-container *ngFor="let moverCtrl of movers.controls; let i = index">
			<label class='mover mover-element' *ngIf="viewMode === 'full' || displayedIndices.includes(i)"
				[formGroupName]="i"
				[ngClass]="{
					'selected': moverCtrl.get('checkbox')?.value,
					'disabled': !canSelect(moverCtrl)
				}">
				<div class='mover-logo'>
					<img [src]='moverCtrl.get("_logo")?.value ? "https://srl.ams3.cdn.digitaloceanspaces.com/logos/" + moverCtrl.get("_logo")?.value : "assets/images/no_logo.png"' />
				</div>
				<div class='mover-content'>
					<div class='score'>
						<div class='rating'>{{ moverCtrl.get('_rating')?.value }}</div>
						<div class='stars'>
							<img *ngFor="let star of getStars(moverCtrl.get('_rating')?.value)" [src]='star' class="star-icon">
						</div>
						<div class='amount'>{{ moverCtrl.get('_amount')?.value }} </div>
					</div>
					<div class='name'>
						{{ moverCtrl.get('_name')?.value }}
					</div>
					<div class='city'>
						{{ moverCtrl.get('_city')?.value }}
					</div>
				</div>
				<div class='mover-actions'>
					<input type="checkbox" 
					       [formControlName]="'checkbox'" 
					       [disabled]="!canSelect(moverCtrl)" 
					       [tabIndex]="formService.verifyTabIndex(formGroupName)"
					       (change)="onCheckboxChange($event, moverCtrl)">
				</div>
			</label>
		</ng-container>
		<label class='more-movers mover-element' 
		       (click)='triggerModal()' 
		       (keydown.enter)='triggerModal()'
		       (keydown.space)='triggerModal()'
		       [tabIndex]='formService.verifyTabIndex(formGroupName)'
		       role='button'
		       aria-label='View other moving companies'
		       *ngIf='viewMode === "default"'>
			<div class='more-movers-label' i18n>
				View other moving companies
			</div>
			<div class='more-movers-action' i18n>
				Adjust your selection
				<mat-icon svgIcon='icons:arrow-right'></mat-icon>
			</div>
		</label>
	</div>
</ng-container>